import script from "./TagSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TagSelector.vue?vue&type=script&setup=true&lang=js"

import "./TagSelector.vue?vue&type=style&index=0&id=24d919b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d919b4"]])

export default __exports__